export default __webpack_public_path__ + "static/media/logo-terra.be9a42dd.png";